<template>
  <VModal :isScroll="false">
    <VSpan
      class="delivery-charge-header"
      slot="header"
      text="배달팁 정보"
      :size="16"
      :color="TextColor.darkGray"
      :weight="TextWeight.bold"
    />
    <VBlock slot="contents" :direction="Direction.column" :padding="[10, 0, 0, 0]">
      <VBlock
        class="discount-wrapper bottom-line"
        ref="scrollLayer"
        :direction="Direction.column"
        :padding="[0, 0, 10, 0]"
        :sort="Sort.left_top"
      >
        <VList>
          <VListItem>
            <VBlock class="discount-header" :sort="Sort.space_between">
              <VSpan
                class="text"
                text="주문금액"
                :size="14"
                :weight="TextWeight.bold"
                :color="TextColor.darkGray"
              />
              <VSpan
                class="text"
                text="배달팁"
                :size="14"
                :weight="TextWeight.bold"
                :color="TextColor.darkGray"
              />
            </VBlock>

            <!-- <VBlock class="discount-header" :sort="Sort.space_between">
              <VSpan text="기본 배달팁" :size="14" :color="TextColor.darkGray" />
              <VSpan
                :text="`${params.defaultDeliveryCharge}원`"
                :size="14"
                :color="TextColor.darkGray"
                :type="TextType.Number"
              />
            </VBlock>
            <VBlock class="discount-header" :sort="Sort.space_between">
              <VSpan text="할인" :size="14" :color="TextColor.darkGray" />
              <VSpan
                :text="`-${params.deliveryCharges[0].discountDeliveryCharge}원`"
                :size="14"
                :color="TextColor.darkGray"
                :type="TextType.Number"
              />
            </VBlock>-->
          </VListItem>
          <VListItem v-for="(deliveryCharge, index) in params.deliveryCharges" :key="index">
            <VBlock class="discount-content" :sort="Sort.space_between">
              <VSpan
                class="text title"
                :text="orderPrice(deliveryCharge.cause)"
                :type="TextType.Number"
                :size="14"
                :color="TextColor.darkGray"
              />
              <VBlock v-if="isProvideDeliveryTipDiscount" class="right" :sort="Sort.left_center">
                <strike
                  v-if="deliveryCharge.deliveryCharge !== deliveryCharge.deliveryChargeBeforeDiscount"
                  class="strike-text"
                >
                  <VSpan
                    class="text strike-text"
                    :text="`${deliveryCharge.deliveryChargeBeforeDiscount}원`"
                    :type="TextType.Number"
                    :size="14"
                    :color="TextColor.darkGray"
                  />
                </strike>
                <VSpan
                  class="text"
                  :text="`${deliveryCharge.deliveryCharge}원`"
                  :type="TextType.Number"
                  :size="14"
                  :color="TextColor.darkGray"
                />
              </VBlock>
              <VSpan
                v-else
                class="text"
                :text="`${deliveryCharge.deliveryCharge}원`"
                :type="TextType.Number"
                :size="14"
                :color="TextColor.darkGray"
              />
            </VBlock>
          </VListItem>
        </VList>
      </VBlock>
      <!-- <VBlock
        class="discount-wrapper"
        :direction="Direction.column"
        :padding="[17, 0, 15, 0]"
        :sort="Sort.left_top"
      >
        <VBlock :sort="Sort.space_between">
          <VSpan text="총 배달팁" :size="14" :color="TextColor.darkGray" :weight="TextWeight.bold" />
          <VSpan
            :text="`${params.defaultDeliveryCharge - params.deliveryCharges[0].discountDeliveryCharge}원`"
            :size="14"
            :color="TextColor.darkGray"
            :type="TextType.Number"
            :weight="TextWeight.bold"
          />
        </VBlock>
      </VBlock>-->
      <VBlock
        class="info-text-wrapper bottom-line"
        :padding="[15, 0, 15, 0]"
        :sort="Sort.left_center"
      >
        <VSpan class="info-text" text="*최소주문금액은 5,000원 입니다." :size="14" :color="TextColor.gray2" />
      </VBlock>

      <VBlock class="info-text-wrapper" :padding="[15, 0, 0, 0]" :sort="Sort.left_center">
        <VSpan
          class="info-text"
          text="배달팁은 라이더에게 지급되는 비용입니다. 고객님이 현장에서 따로 결제해야 하는 불편함을 덜기 위해, B마트가 대신 결제를 받아 전달해 드립니다. 배달팁 금액은 주문하신 금액에 따라 달라질 수 있습니다."
          :size="11"
          :color="TextColor.gray2"
        />
      </VBlock>
    </VBlock>

    <VBlock slot="footer" class="button-wrapper">
      <VButton class="cancel-button" :color="ButtonColor.none" :onClick="onOK">
        <VSpan text="확인" :size="16" :color="TextColor.black" :weight="TextWeight.bold" />
      </VButton>
    </VBlock>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VHR from '@/presentationals/v2/components/layouts/atoms/VHR'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal from '@/presentationals/v2/components/layouts/molecules/VModal'

import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import { isProvideDeliveryTipDiscount } from '../../../../../../config/featureProvider'

export default {
  name: 'ModalDevlieryCharge',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  mounted() {
    // console.log(this.params.defaultDeliveryCharge)
    // console.log(this.params)
    disableBodyScroll(this.$refs.scrollLayer.$el)
  },
  beforeDestroy() {
    enableBodyScroll(this.$refs.scrollLayer.$el)
  },
  components: {
    VButton,
    VSpan,
    VHR,

    VBlock,
    VModal,

    VList,
    VListItem
  },
  methods: {
    orderPrice(cause) {
      if (!cause.endAmount) return `${cause.startAmount}원 ~`
      return `${cause.startAmount}원 ~ ${cause.endAmount}원 미만`
    }
  },
  computed: {
    isProvideDeliveryTipDiscount() {
      return isProvideDeliveryTipDiscount
    }
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.bottom-line {
  border-bottom: 1px solid $light-gray-5;
}

.discount-wrapper {
  // box-sizing: border-box;
  // padding: 10px 0 16px 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;

  .discount-header {
    // width: 100%;
    // height: 24px;
    // box-sizing: border-box;

    padding-bottom: 10px;
    // position: relative;

    /* .text {
      // height: 20px;
      text-align: left;

      &:first-child {
        width: 95px;
        margin-right: 10px;
      }
      &:last-child {
        width: 60px;
      }
    } */
  }

  .discount-content {
    // height: 20px !important;
    // box-sizing: border-box;
    margin-bottom: 5px;

    .title {
      text-align: left;
      width: auto;
    }

    .text {
      white-space: nowrap;
    }

    .strike-text {
      color: $light-gray-4;
      margin-right: 2px;
      // height: 20px;
      /* text-align: left; */

      /* &:first-child {
        width: 95px;
        margin-right: 10px;
      } */
      /* &:last-child {
        text-align: right;
        width: auto;

        .strike {
          margin-right: 4px;
        }
      } */
    }

    .right {
      width: auto;
    }
  }
}

.info-text-wrapper {
  // padding: 15px 0 0 0;
  box-sizing: border-box;

  .info-text {
    text-align: left;
  }
}

.button-wrapper {
  .cancel-button {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  }
}
</style>